<div class="dashboard-layout">
  <!-- Top Banner -->
  <header class="top-banner">
    <div class="logo-area">
      <button class="mobile-menu-btn" (click)="toggleMobileMenu()">
        ☰
      </button>
    </div>
    <div class="user-actions">
      <!-- Request Refund / Refund Status Link in Top Banner -->
      @if (hasRefundRequests) {
      <a routerLink="/home/refund-status" class="top-refund-btn">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        Refund Status
      </a>
      } @else {
      <a routerLink="/home/refund" class="top-refund-btn">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        Experiencing Issues?
      </a>
      }

      <!-- User Profile Badge -->
      <div class="profile-badge-container" (click)="$event.stopPropagation()">
        <button class="profile-pill-btn" (click)="toggleProfilePopup($event)">
          @if (userPhotoUrl) {
          <img [src]="userPhotoUrl" alt="Avatar" class="avatar-img" />
          } @else {
          <div class="avatar-initials">{{ userInitials }}</div>
          }
          <span class="user-name">{{ userName }}</span>
        </button>

        @if (isProfilePopupOpen) {
        <div class="profile-dropdown-card fade-in">
          <div class="dropdown-header">
            @if (userPhotoUrl) {
            <img [src]="userPhotoUrl" alt="Avatar" class="dropdown-avatar-img" />
            } @else {
            <div class="dropdown-avatar-initials">{{ userInitials }}</div>
            }
            <div class="dropdown-details">
              <div class="dropdown-name">{{ userName }}</div>
              <div class="dropdown-email">📧 {{ userEmail }}</div>
              @if (userProfile?.role) {
              <div class="dropdown-role">{{ userProfile.role }}</div>
              }
            </div>
          </div>
        </div>
        }
      </div>

      <button class="logout-btn" (click)="logout()">Logout</button>
    </div>
  </header>

  <div class="main-body">
    <!-- Overlay for mobile -->
    @if (isMobileMenuOpen) {
    <div class="mobile-overlay" (click)="closeMobileMenu()"></div>
    }

    <!-- Left Menu -->
    <aside class="left-menu" [class.mobile-open]="isMobileMenuOpen">
      <nav>
        <ul>
          <li>
            <a routerLink="/home/gallery" routerLinkActive="active" (click)="closeMobileMenu()">
              My Gallery
            </a>
          </li>
          @if (isSessionActive) {
          <li>
            <a class="active">
              Current Session
            </a>
          </li>
          }
          @if (hasRefundRequests) {
          <li>
            <a routerLink="/home/refund-status" routerLinkActive="active" (click)="closeMobileMenu()">
              Refund Status
            </a>
          </li>
          } @else {
          <li>
            <a routerLink="/home/refund" routerLinkActive="active" (click)="closeMobileMenu()">
              Experiencing Issues?
            </a>
          </li>
          }
        </ul>
      </nav>
    </aside>

    <!-- Main Content Area -->
    <main class="content-area">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
      <footer class="portal-footer">
        <span>&copy; 2026 K PhotoLaVie. All rights reserved.</span>
        <div class="footer-links">
          @if (hasRefundRequests) {
          <a routerLink="/home/refund-status">Refund Status</a>
          <span>&bull;</span>
          }
          <a routerLink="/home/refund">Experiencing Issues?</a>
          <span>&bull;</span>
          <a routerLink="/terms" target="_blank">Terms of Service</a>
          <span>&bull;</span>
          <a routerLink="/privacy" target="_blank">Privacy Policy</a>
        </div>
      </footer>
    </main>
  </div>
</div>